<template>
  <div class="car-config-wrap">
    <div class="max-box">
      <!-- 左侧固定栏 + 导航 -->
      <div class="left-fixed-wrap">
        <div class="left-fixed">
          <div class="param-title">参数配置</div>
          <div class="nav-group">
            <div
              :key="idx"
              class="nav-item"
              v-for="(group, idx) in configList"
              @click="scrollToGroup(group.key)">
              {{ group.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 整体滚动容器 -->
      <!-- <div class="mock">dd</div> -->
      <div class="table-scroll-box" ref="tableScrollBox">
        <!-- <div class="max-box3"> -->
        <div class="car-column">
          <div class="car-name">车型</div>
          <div
            :key="idx"
            :data-key="group.key"
            class="group-section"
            v-for="(group, idx) in configList1">
            <div class="group-title-sticky" :class="{ sticky: isSticky }">
              {{ group.name }}
            </div>
            <div :key="i" class="param-item" v-for="(item, i) in group.items">
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="table-inner">
          <!-- 右侧参数内容 -->
          <div class="right-content">
            <div class="max-box2">
              <div class="car-column" v-for="car in configList3" :key="car.key">
                <div class="car-name">{{ car.name }}6</div>
                <!-- 分组 + 吸顶标题 -->
                <div
                  :key="idx"
                  :data-key="group.key"
                  class="group-section"
                  v-for="(group, idx) in car.Arr">
                  <div class="group-title-sticky" :class="{ sticky: isSticky }">
                    <!-- {{ group.name }} -->
                    &ensp;
                  </div>
                  <div
                    :key="i"
                    class="param-item"
                    v-for="(item, i) in group.items">
                    {{ item.name }}
                  </div>
                </div>
              </div>

              <!-- --------------------------- -->
            </div>
          </div>
        </div>

        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { configList3 } from '@/assets/js/static3'
export default {
  name: 'CarConfigTable',
  data() {
    return {
      configList3,
      activeKey: 'model1',
      isSticky: false,
      carList1: [{ key: 'model1', name: '车型' }],
      carList: [
        { key: 'model1', name: '2025款 畅享版' },
        { key: 'model2', name: '2025款 舒享版' },
        { key: 'model3', name: '2025款 尊享版' },
        { key: 'model4', name: '2025款 旗舰版' },
        { key: 'model5', name: '2025款 至尊版' },
        // { key: 'model6', name: '2025款 旗舰四驱版' },
      ],
      configList1: [
        {
          key: 'base',
          name: '基础参数',
          items: [
            { name: '车身长度(mm)' },
            { name: '车身宽度(mm)' },
            { name: '车身高度(mm)' },
            { name: '轴距(mm)' },
            { name: '前轮距(mm)' },
            { name: '后轮距(mm)' },
            { name: '最小离地间隙(mm)' },
            { name: '整备质量(kg)' },
          ],
        },
        {
          key: 'power',
          name: '动力系统',
          items: [
            { name: '发动机型号' },
            { name: '排量(mL)' },
            { name: '进气形式' },
            { name: '最大马力(Ps)' },
            { name: '最大扭矩(N·m)' },
            { name: '变速箱类型' },
            { name: '挡位个数' },
            { name: '驱动方式' },
            { name: '四驱形式' },
            { name: '中央差速器结构' },
          ],
        },
        {
          key: 'chassis',
          name: '底盘转向',
          items: [
            { name: '前悬挂类型' },
            { name: '后悬挂类型' },
            { name: '助力类型' },
            { name: '车体结构' },
            { name: '前制动器类型' },
            { name: '后制动器类型' },
          ],
        },
        {
          key: 'wheel',
          name: '车轮制动',
          items: [
            { name: '前轮胎规格' },
            { name: '后轮胎规格' },
            { name: '备胎规格' },
            { name: '轮毂材质' },
          ],
        },
        {
          key: 'safe',
          name: '安全装备',
          items: [
            { name: '主驾安全气囊' },
            { name: '副驾安全气囊' },
            { name: '前排侧气囊' },
            { name: '前后排头部气囊' },
            { name: '胎压监测' },
            { name: '车身稳定控制' },
            { name: '并线辅助' },
            { name: '车道偏离预警' },
          ],
        },
        {
          key: 'assist',
          name: '辅助操控',
          items: [
            { name: '前后驻车雷达' },
            { name: '360°全景影像' },
            { name: '定速巡航' },
            { name: '自适应巡航' },
            { name: '自动泊车' },
            { name: '上坡辅助' },
            { name: '陡坡缓降' },
          ],
        },
        {
          key: 'external',
          name: '外部配置',
          items: [
            { name: '全景天窗' },
            { name: '运动外观套件' },
            { name: '电动后备箱' },
            { name: '感应后备箱' },
            { name: '车顶行李架' },
            { name: 'LED日间行车灯' },
            { name: '自动大灯' },
          ],
        },
        {
          key: 'internal',
          name: '内部配置',
          items: [
            { name: '真皮方向盘' },
            { name: '方向盘加热' },
            { name: '全液晶仪表' },
            { name: 'HUD抬头显示' },
            { name: '内置行车记录仪' },
            { name: '手机无线充电' },
          ],
        },
        {
          key: 'seat',
          name: '座椅配置',
          items: [
            { name: '真皮座椅' },
            { name: '主驾电动调节' },
            { name: '副驾电动调节' },
            { name: '前排座椅加热' },
            { name: '前排座椅通风' },
            { name: '后排座椅加热' },
            { name: '后排杯架' },
          ],
        },
        {
          key: 'media',
          name: '多媒体',
          items: [
            { name: '中控彩色屏' },
            { name: 'GPS导航' },
            { name: '道路救援' },
            { name: '蓝牙/车载电话' },
            { name: '车联网' },
            { name: 'OTA升级' },
            { name: '音响品牌' },
            { name: '扬声器数量' },
          ],
        },
        {
          key: 'air',
          name: '空调/冰箱',
          items: [
            { name: '自动空调' },
            { name: '后排独立空调' },
            { name: '后座出风口' },
            { name: '温度分区控制' },
            { name: '车载空气净化器' },
            { name: '车内PM2.5过滤' },
          ],
        },
      ],
      configList: [
        {
          key: 'base',
          name: '基础参数',
          items: [
            { name: '车身长度(mm)' },
            { name: '车身宽度(mm)' },
            { name: '车身高度(mm)' },
            { name: '轴距(mm)' },
            { name: '前轮距(mm)' },
            { name: '后轮距(mm)' },
            { name: '最小离地间隙(mm)' },
            { name: '整备质量(kg)' },
          ],
        },
        {
          key: 'power',
          name: '动力系统',
          items: [
            { name: '发动机型号' },
            { name: '排量(mL)' },
            { name: '进气形式' },
            { name: '最大马力(Ps)' },
            { name: '最大扭矩(N·m)' },
            { name: '变速箱类型' },
            { name: '挡位个数' },
            { name: '驱动方式' },
            { name: '四驱形式' },
            { name: '中央差速器结构' },
          ],
        },
        {
          key: 'chassis',
          name: '底盘转向',
          items: [
            { name: '前悬挂类型' },
            { name: '后悬挂类型' },
            { name: '助力类型' },
            { name: '车体结构' },
            { name: '前制动器类型' },
            { name: '后制动器类型' },
          ],
        },
        {
          key: 'wheel',
          name: '车轮制动',
          items: [
            { name: '前轮胎规格' },
            { name: '后轮胎规格' },
            { name: '备胎规格' },
            { name: '轮毂材质' },
          ],
        },
        {
          key: 'safe',
          name: '安全装备',
          items: [
            { name: '主驾安全气囊' },
            { name: '副驾安全气囊' },
            { name: '前排侧气囊' },
            { name: '前后排头部气囊' },
            { name: '胎压监测' },
            { name: '车身稳定控制' },
            { name: '并线辅助' },
            { name: '车道偏离预警' },
          ],
        },
        {
          key: 'assist',
          name: '辅助操控',
          items: [
            { name: '前后驻车雷达' },
            { name: '360°全景影像' },
            { name: '定速巡航' },
            { name: '自适应巡航' },
            { name: '自动泊车' },
            { name: '上坡辅助' },
            { name: '陡坡缓降' },
          ],
        },
        {
          key: 'external',
          name: '外部配置',
          items: [
            { name: '全景天窗' },
            { name: '运动外观套件' },
            { name: '电动后备箱' },
            { name: '感应后备箱' },
            { name: '车顶行李架' },
            { name: 'LED日间行车灯' },
            { name: '自动大灯' },
          ],
        },
        {
          key: 'internal',
          name: '内部配置',
          items: [
            { name: '真皮方向盘' },
            { name: '方向盘加热' },
            { name: '全液晶仪表' },
            { name: 'HUD抬头显示' },
            { name: '内置行车记录仪' },
            { name: '手机无线充电' },
          ],
        },
        {
          key: 'seat',
          name: '座椅配置',
          items: [
            { name: '真皮座椅' },
            { name: '主驾电动调节' },
            { name: '副驾电动调节' },
            { name: '前排座椅加热' },
            { name: '前排座椅通风' },
            { name: '后排座椅加热' },
            { name: '后排杯架' },
          ],
        },
        {
          key: 'media',
          name: '多媒体',
          items: [
            { name: '中控彩色屏' },
            { name: 'GPS导航' },
            { name: '道路救援' },
            { name: '蓝牙/车载电话' },
            { name: '车联网' },
            { name: 'OTA升级' },
            { name: '音响品牌' },
            { name: '扬声器数量' },
          ],
        },
        {
          key: 'air',
          name: '空调/冰箱',
          items: [
            { name: '自动空调' },
            { name: '后排独立空调' },
            { name: '后座出风口' },
            { name: '温度分区控制' },
            { name: '车载空气净化器' },
            { name: '车内PM2.5过滤' },
          ],
        },
      ],
    }
  },
  methods: {
    // selectCar(key) {
    //   this.activeKey = key;
    // },
    // 点击左侧导航 → 滚动到对应分组
    scrollToGroup(key) {
      const el = document.querySelector(`.group-section[data-key="${key}"]`)
      if (el) {
        this.$refs.tableScrollBox.scrollTo({
          top: el.offsetTop - 50,
          behavior: 'smooth',
        })
      }
    },
  },
  mounted() {
    // 监听滚动 → 吸顶
    this.$refs.tableScrollBox.addEventListener('scroll', () => {
      console.log('scrollTop :>> ', this.$refs.tableScrollBox.scrollTop)
      this.isSticky = this.$refs.tableScrollBox.scrollTop > 48
    })
  },
}
</script>

<style scoped lang="scss">
.group-title-sticky {
}
.car-config-wrap {
  width: 100%;
  // background: #fff;
}

.max-box {
  display: flex;
  position: relative;
}

.mock {
  width: 100px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #f00;
}

.max-box3 {
  width: 60%;
  overflow-x: auto;
  display: flex;
  position: relative;
}

.max-box2 {
  display: flex;
}

/* 纵向滚动容器（产生滚动条） */
.table-scroll-box {
  display: flex;
  // justify-content: space-between;
  // align-items: center;
  width: 60%;
  // width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
  // position: relative;
  -webkit-overflow-scrolling: touch;
}

/* 横向布局：左侧固定 + 右侧滚动 */
.table-inner {
  display: flex;
  width: fit-content;
}

/* ========== 左侧固定 永久不动 ========== */
.left-fixed-wrap {
  width: 130px;
  flex-shrink: 0;
  position: sticky;
  left: 0;
  z-index: 99;
  // background: #f7f7f7;
}
.left-fixed {
  width: 100%;
  border-right: 1px solid #eee;
}
.param-title {
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  // background: #f7f7f7;
  border-bottom: 1px solid #eee;
}

/* 左侧导航 */
.nav-group {
  width: 100%;
}
.nav-item {
  padding: 12px 8px;
  font-size: 13px;
  color: #333;
  border-bottom: 1px solid #eee;
  text-align: center;
  // background: #f7f7f7;
}
.nav-item:active {
  background: #eef2ff;
}

/* ========== 右侧内容 ========== */
.right-content {
  display: flex;
}
.car-column {
  width: 120px;
  flex-shrink: 0;
  text-align: center;
  // background: #fff;
}
.car-column.active {
  // background: #f5f9ff;
}
.car-name {
  height: 48px;
  line-height: 48px;
  font-size: 13px;
  color: #005eff;
  font-weight: 500;
  border-bottom: 1px solid #eee;
}

/* 分组 + 吸顶标题 */
.group-section {
  width: 115%;
}
.group-title-sticky {
  position: sticky;
  top: 0;
  z-index: 10;
  // background: #f2f2f2;
  color: #666;
  font-size: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
.group-title-sticky.sticky {
  top: 0;
  background: #eaefff;
  color: #005eff;
}

/* 参数行 */
.param-item {
  padding: 12px 0;
  font-size: 13px;
  color: #333;
  border-bottom: 1px solid #eee;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
